var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiddenSecret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_305_39924",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.75L19.5 20.25M14.522 14.775C13.8338 15.4054 12.9334 15.7536 12.0001 15.75C11.2432 15.7499 10.5041 15.5208 9.87984 15.0928C9.25561 14.6648 8.77551 14.0579 8.50265 13.3519C8.22979 12.6459 8.17695 11.8739 8.35107 11.1373C8.52519 10.4007 8.91812 9.73409 9.47821 9.22501M6.9375 6.43124C3.1125 8.36249 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C13.7574 18.7643 15.4929 18.3594 17.0625 17.5687M19.5564 15.8531C21.6002 14.025 22.5002 12 22.5002 12C22.5002 12 19.5002 5.24999 12.0002 5.24999C11.35 5.24871 10.7008 5.30202 10.0596 5.40937M12.7031 8.31561C13.5006 8.46671 14.2273 8.87311 14.7735 9.47347C15.3198 10.0738 15.6559 10.8356 15.7313 11.6437",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_305_39924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenSecret);
export default __webpack_public_path__ + "static/media/hidden-secret.8d64c05c5800acdb4e24e87e964e1bc1.svg";
export { ForwardRef as ReactComponent };